import { render, staticRenderFns } from "./BalanceEmptyBlock.vue?vue&type=template&id=39e3e360&scoped=true"
import script from "./BalanceEmptyBlock.vue?vue&type=script&lang=js"
export * from "./BalanceEmptyBlock.vue?vue&type=script&lang=js"
import style0 from "./BalanceEmptyBlock.vue?vue&type=style&index=0&id=39e3e360&prod&scoped=true&class=scss&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e3e360",
  null
  
)

export default component.exports